import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import type { Header } from '@tanstack/react-table';

const TableColumnSorter = ({ header }: TableColumnSorterProps) => {
  const isAscSelected = header.column.getIsSorted() == 'asc';
  const isDescSelected = header.column.getIsSorted() == 'desc';

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      style={{ marginLeft: '0.3rem' }}
    >
      <FontAwesomeIcon
        icon={isAscSelected ? faChevronUp : faChevronUp}
        size={isAscSelected ? '1x' : 'xs'}
      />
      <FontAwesomeIcon
        icon={isDescSelected ? faChevronDown : faChevronDown}
        size={isDescSelected ? '1x' : 'xs'}
        style={{ cursor: 'pointer' }}
      />
    </Box>
  );
};

export default TableColumnSorter;

type TableColumnSorterProps = {
  header: Header<unknown, unknown>;
};
